<!-- 
  详情页 - 产品详情
  props:
    id: 详情产品id
  emit:暂无
 -->
<template>
  <div class="product-tab">
    <h1 class="theme"><i></i><span>基本信息</span></h1>
    <ul class="base-info">
      <li class="base-info-item" v-for="Info in baseInfo" :key="Info.attr">
        <el-tooltip effect="dark"  placement="top" popper-class="info-pop-class">
          <div slot="content">{{Info.value4Show}}</div>
          <span>{{Info.attrName}} ： {{Info.value4Show}}</span>   
        </el-tooltip>
      </li>
    </ul>

    <h1 class="theme"><i></i><span>产品图片</span></h1>
    <ul class="img-list">
      <li class="empty"  v-if="!imageInfo.length">暂无相关产品图片</li>
      <li
        class="img"
        v-for="img in imageInfo"
        :key="img">
        <img :src="img" @click="imgBig(img)"/>
      </li>
    </ul>

    <h1 class="theme"><i></i><span>产品介绍</span></h1>
    <div class="ql-snow" v-if="instructionInfo">
      <div class="ql-editor" v-html="instructionInfo"></div>
    </div>
    <div class="empty" v-else>暂无产品介绍</div>

    <h1 class="theme"><i></i><span>产品文件</span></h1>
    <ul class="file-list">
      <li class="file" v-for="(item, index) in fileList" :key="index">
        <div class="file-item">
          <div class="icon" :class="fileIcoPath(item)"></div>
          <div class="file-con">
            <div class="file-name">
              <p class="title">{{item.filename}}</p>
              <p class="size">{{item.size | formatUnit}}</p>
            </div>
            <div class="operate">
              <a class="preview-btn" target="_blank"  :href="clickPreview(item)" v-if="isShowFile(item)">预览</a>
              <a class="download-btn" :download="item.filename" :href="item.attachIndex">下载</a>
            </div>
          </div>
        </div>
      </li>
      <li class="empty" v-if="!fileList.length">暂无相关文件</li>
    </ul>
    <h1 class="theme"><i></i><span>其它信息</span></h1>
    <ul class="other-infos">
      <li class="other-item">
        <span>创建人：</span>
        <span>{{creator || '--'}}</span>
      </li>
      <li class="other-item">
        <span>创建时间：</span>
        <span>{{addTime || '--'}}</span>
      </li>
      <li class="other-item">
        <span>最后更新人：</span>
        <span>{{updater || '--'}}</span>
      </li>
      <li class="other-item">
        <span>最后更新时间：</span>
        <span>{{updateTime || '--'}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'

export default {
  created () {
    this.getTabCon()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      baseInfo: [], // 基本信息
      imageInfo: [], // 产品图片
      instructionInfo: '', // 产品介绍
      addTime: '', // 创建时间
      creator: '', // 创建人
      updateTime: '', // 最后更新时间
      updater: '', // 最后更新人
      fileList: [] // 文件列表
    }
  },
  methods: {
    // 获取产品接口
    getTabCon () {
      let url = `/productApi/productDetail.html`
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.baseInfo = data.baseInfo
        // this.imageInfo = imageInfoArray
        this.instructionInfo = data.instructionInfo.value4Show
        this.addTime = data.otherInfo.addTime
        this.creator = data.otherInfo.creator
        this.updateTime = data.otherInfo.updateTime
        this.updater = data.otherInfo.updater

        // 文件列表格式化
        if (data.fileInfoArray && data.fileInfoArray.length) {
          let arr = []
          data.fileInfoArray.forEach(item => {
            if (!item.value4Show) {
              arr = []
            } else {
              arr = arr.concat(JSON.parse(item.value4Show))
            }
          })
          this.fileList = arr
        }

        // 图片列表格式化
        if (data.imageInfoArray && data.imageInfoArray.length) {
          let arr = []
          data.imageInfoArray.forEach(item => {
            if (!item.value4Show) {
              arr = []
            } else {
              arr = arr.concat(JSON.parse(item.value4Show))
            }
          })
          this.imageInfo = arr
        }
      })
    },
    // 点击预览
    clickPreview (file) {
      let reg = /attachIndex=[^&$]+/
      let fileLink
      if (reg.test(file.attachIndex)) {
        fileLink = file.attachIndex.match(reg)[0].split('=')[1]
      } else {
        fileLink = file.attachIndex
      }
      if (['office', 'pdf'].includes(this.isShowFile(file))) {
        return 'https://view.xbongbong.com/view/url?url=' + fileLink
      } else {
        return fileLink
      }
    },
     // 处理文件后缀为图片，txt,excel,word,pdf
    isShowFile (file) {
      let ext
      if (file.ext) {
        ext = file.ext.toLowerCase()
      } else {
        ext = file.attachIndex.slice(file.attachIndex.lastIndexOf('.') + 1).toLowerCase()
      }
      return utils.getFileViewType(ext)
    },
    // 通过后缀名获取关联图标
    fileIcoPath (file) {
      let ext
      if (file.ext) {
        ext = file.ext.toLowerCase()
      } else {
        ext = file.attachIndex.slice(file.attachIndex.lastIndexOf('.') + 1).toLowerCase()
      }
      return utils.getFileType(ext)
    },
    // 图片放大
    imgBig (item) {
      lightBox(item)
    }
  },

  filters: {
    toUpperCase (str) {
      return str.toUpperCase()
    },

    // 对文件大小单位进行格式化
    formatUnit (size) {
      if (size > 999999) {
        return (size / 1024 / 1024).toFixed(2) + 'MB'
      } else if (size > 999) {
        return (size / 1024).toFixed(2) + 'KB'
      } else {
        return size + 'B'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable.less";

.product-tab {
  .noInfo {
    color: #9a9a9a;
  }
  padding: 0 15px;
  .theme {
    background: #f1f6fe;
    line-height: 30px;
    font-size: 13px;
    font-weight: bold;
    color: #222222;
  }
  .theme i {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #ff943e;
    margin: 0 10px;
  }
  .base-info {
    font-size: 0;
    padding: 10px 20px 20px;
    box-sizing: border-box;
    .base-info-item {
      width: 45%;
      margin-right: 5%;
      display: inline-block;
      font-size: 13px;
      line-height: 1;
      margin-top: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .img-list {
    font-size: 0;
    padding: 0 10px 18px 0;
    .img {
      display: inline-block;
      margin: 18px 0 0 18px;
      img {
        width: 80px;
        height: 80px;
        cursor: pointer;
      }
    }
  }
  .instruction {
    padding: 20px;
    line-height: 1.8;
    font-size: 13px;
    text-indent: 2em;
    text-align: justify;
  }
  .other-infos {
    padding: 5px 20px 20px;
    .other-item {
      font-size: 13px;
      margin-top: 15px;
    }
  }
  .file-list {
    font-size: 0;
    padding-bottom: 15px;
    .file {
      width: 50%;
      display: inline-block;
      .file-item {
        padding: 15px 0 0 20px;
        .icon {
          display: inline-block;
          vertical-align: top;
          width: 46px;
          height: 46px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../../assets/imgs/ic_file_other.png');
          &.image {
            background-image: url('../../../assets/imgs/ic_file_image.png');
          }
          &.txt {
            background-image: url('../../../assets/imgs/ic_file_text.png');
          }
          &.zip {
            background-image: url('../../../assets/imgs/ic_file_zip.png');
          }
          &.sounds {
            background-image: url('../../../assets/imgs/ic_file_sounds.png');
          }
          &.excel {
            background-image: url('../../../assets/imgs/ic_file_excel.png');
          }
          &.pdf {
            background-image: url('../../../assets/imgs/ic_file_pdf.png');
          }
          &.word {
            background-image: url('../../../assets/imgs/ic_file_word.png');
          }
          &.ppt {
            background-image: url('../../../assets/imgs/ic_file_ppt.png');
          }
          &.video {
            background-image: url('../../../assets/imgs/ic_file_video.png');
          }
          &.html {
            background-image: url('../../../assets/imgs/ic_file_html.png');
          }
        }
        .file-con {
          position: relative;
          display: inline-block;
          box-sizing: border-box;
          vertical-align: top;
          padding: 7px 10px 0 8px;
          width: 300px;
          font-size: 13px;
          height: 46px;
          border: #dce1e8 solid 1px;
          border-left: 0;
          .file-name {
            float: left;
          }
          .title {
            width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .size {
            color: @light-gray;
            margin-top: 6px;
          }
          .operate {
            float: right;
          }
          .preview-btn {
            padding-right: 10px;
          }
          .download-btn {
            padding-left: 10px;
            line-height: 28px;
            text-align: center;
            border-left: 1px solid #dce1e8;
            color: @primary;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .empty {
    text-align: center;
    line-height: 3;
    font-size: 14px;
    text-indent: 0;
  }
  .ql-snow {
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// product-tab.vue?798a2970